export default "__VITE_ASSET__083XZI$J__"